import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import { Black, Dark2, WerfenColor, White } from '../../Constants/ColorChart'
import Button from '../Button/Button'
import { bindActionCreators } from "redux";
import { hideDialog } from "../../../actions/ui";
import { connect } from "react-redux";
import isElectron from "is-electron";
import { withRouter } from "react-router-dom";

let electron;

if ( isElectron() ) {
    electron = window.require( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;
/*
 *  @Description:   Component that renders a substitute to alert and confirm window boxes.
 */

const DialogBackground = styled.div`
    background: rgba(0,0,0,0.6);
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 39;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const DialogWrapper = styled.div`
    display: flex;
    flex-direction:column; 
    width: 500px;
    min-height: 250px;
    border: 2px solid ${ Dark2 };
    position: absolute;
    background: ${ White }
    display: flex;
`;

const DialogDivHeader = styled.div`
    background: ${ WerfenColor };
    color: ${ White };
    padding: 10px;
`;

const DialogDivBody = styled.div`
    padding: 2%;
    color: ${ Black };
    flex-grow: 1;
`;

const DialogFooter = styled.div`
    display: flex;
    margin-bottom: 2%; 
    justify-content: flex-end;
`;

const Dialog = ( props ) => {
    const { dialogTitle, dialogBody, onAccept, onAcceptCallback, onCancel, onCancelCallback, callback } = props;
    const [ overflowY, setOverFlowY ] = useState( null );

    useEffect( () => {
        setOverFlowY( document.body.style.overflowY );
        document.body.style.overflowY = 'hidden';
        return () => {
            document.body.style.overflowY = overflowY
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const dismissDialog = ( data ) => {
        props.hideDialog();
        const { confirm, callback } = data;
        if ( confirm && typeof callback === "function" ) {
            callback();
        }
    }

    return (
        <DialogBackground>
            <DialogWrapper>
                <DialogDivHeader>
                    { dialogTitle }
                </DialogDivHeader>
                <DialogDivBody>
                    { dialogBody.map( ( line, index ) => {
                        return <p key={ index }>{ line }</p>;
                    } ) }
                </DialogDivBody>
                <DialogFooter>
                    { onAccept !== undefined && <Button
                        className={ "cancel" }
                        text={ "Cancel" }
                        background={ White }
                        color={ WerfenColor }
                        onClick={ () => {
                            const data = {
                                confirm: false
                            }
                            if ( onCancel && onCancel.channel ) {
                                if(isElectron() ) {
                                    ipcRenderer.send( onCancel.channel, onCancel.args );
                                }
                            }
                            if ( onCancelCallback ) {
                                data.callback = onCancelCallback
                            }
                            dismissDialog( data )
                        } }
                    /> }
                    <Button
                        className={ "accept" }
                        text={ "OK" }
                        background={ WerfenColor }
                        color={ White }
                        onClick={ () => {
                            const data = {
                                confirm: true
                            }
                            if ( onAccept && onAccept.channel ) {
                                if(isElectron()) {
                                    ipcRenderer.send( onAccept.channel, onAccept.args );
                                }
                            }
                            if ( onAcceptCallback ) {
                                data.callback = onAcceptCallback
                            } else {
                                data.callback = callback
                            }
                            dismissDialog( data );
                        } }
                    />
                </DialogFooter>
            </DialogWrapper>
        </DialogBackground>

    );

}

const mapStateToProps = ( state ) => ({
    dialogTitle: state.ui.dialogTitle,
    dialogBody: state.ui.dialogBody,
    onAccept: state.ui.onAccept,
    // onCancel: state.ui.onCancel,
    callback: state.ui.callback
})

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators( {
        hideDialog: hideDialog,
    }, dispatch );
}

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( Dialog ) );